import { useState } from "react";
import { ERROR_MESSAGES } from "../../constant/constant";
import { useTenantAuth } from "../../context/TeanantAuthProvider";
import { useAxios } from "../../utils/useAxios";

/**
 * Custom hook for tenant logout functionality
 * @returns {{
 *   loading: boolean,
 *   error: string,
 *   success: boolean,
 *   tenantLogout: () => Promise<void>,
 *   resetState: () => void
 * }}
 */
export const useTenantLogout = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const { logout } = useTenantAuth();
  const { axiosInstance } = useAxios();

  const tenantLogout = async () => {
    setLoading(true);
    setError("");
    setSuccess(false);
    try {
      await axiosInstance.post("/tenant/auth/logout", {});
      logout();
      setSuccess(true);
    } catch (err) {
      if (err.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
      // Don't logout on error - let user retry or cancel
    } finally {
      setLoading(false);
    }
  };

  const resetState = () => {
    setLoading(false);
    setError("");
    setSuccess(false);
  };

  return { loading, error, success, tenantLogout, resetState };
};
